// migracionSchema.tsx

import * as yup from 'yup';

export const migracionSchema = yup.object({

});
